<template>
  <section class="cart">
    <header class="cart__header">
      <headline>{{ $t('title') }}</headline>
    </header>

    <template v-if="$store.state.cart.reservations.count > 0">
      <div class="cart__content">
        <div class="cart__ticket">
          <h3 class="cart__subtitle">
            <span>{{ $t('admission') }}</span>
          </h3>
          <div class="cart__datetime">
            <span class="cart__date">
              {{ $t('selectedDate') }}: <strong>{{ humanDate($store.state.cart.reservations.date) }}</strong>
            </span>
            <span class="cart__time">
              {{ $t('arrivalSlot') }}: <strong>{{ reservationsGapTime }}</strong>
            </span>
            <span class="cart__quantity">
              {{ $t('quantity.title') }}:
              <strong>
                {{ $store.state.cart.reservations.count }}
                {{ $tc('quantity.unit', $store.state.cart.reservations.count) }}
              </strong>
            </span>
          </div>
        </div>
      </div>

      <footer class="cart__footer">
        <action-link
          :router-link="$t('backToReservation.link')"
          exact
        >
          <icon
            type="chevron-left"
            :size="0.75"
          />
          {{ $t('backToReservation.text') }}
        </action-link>

        <action-link
          :router-link="$t('completeReservation.link')"
          color="primary"
        >
          {{ $t('completeReservation.text') }}
          <icon
            type="chevron-right"
            :size="0.75"
          />
        </action-link>
      </footer>
    </template>

    <template v-else>
      <div class="cart__content">
        <p class="cart__note">
          {{ $t('emptyCart') }}
        </p>
      </div>

      <footer class="cart__footer">
        <action-link
          :router-link="$t('ticketReservation.link')"
          color="primary"
          exact
        >
          <icon
            type="chevron-left"
            :size="0.75"
          />
          {{ $t('ticketReservation.text') }}
        </action-link>
      </footer>
    </template>
  </section>
</template>

<script>
import cartMixin from '../mixins/cart'

import actionLink from './actionLink.vue'
import headline from './headline.vue'
import icon from './icon.vue'

export default {
  name: 'CCartReservation',

  components: {
    actionLink,
    headline,
    icon
  },

  mixins: [cartMixin]
}
</script>

<i18n locale="en">
{
  "title": "Reservation summary",
  "emptyCart": "Your shopping cart is empty!",
  "admission": "Reservations Miniatur Wunderland Hamburg",
  "selectedDate": "Chosen Date",
  "arrivalSlot": "Time Slot of Arrival",
  "quantity": {
    "title": "Quantity",
    "unit": "Person | Persons"
  },
  "backToReservation": {
    "text": "Ticket Reservation",
    "link": "/reservation"
  },
  "completeReservation": {
    "text": "Complete Reservation",
    "link": "/reservation/personal-information"
  },
  "ticketReservation": {
    "text": "Ticket Reservation",
    "link": "/reservation"
  }
}
</i18n>

<i18n locale="de">
{
  "title": "Reservierungsübersicht",
  "emptyCart": "Sie haben keine Artikel im Warenkorb!",
  "admission": "Reservierungen Miniatur Wunderland Hamburg",
  "selectedDate": "Gewähltes Datum",
  "arrivalSlot": "Einlasszeit",
  "quantity": {
    "title": "Anzahl",
    "unit": "Person | Personen"
  },
  "backToReservation": {
    "text": "Reservierung ändern",
    "link": "/reservierung"
  },
  "completeReservation": {
    "text": "Reservierung abschließen",
    "link": "/reservierung/persoenliche-daten"
  },
  "ticketReservation": {
    "text": "Zur Ticketreservierung",
    "link": "/reservierung"
  }
}
</i18n>
